<template>
  <div class="container-custom">
    <!-- breadcrumbs -->
    <Breadscrumbs
      :links="[
        {
          name: 'SubCategories',
          to: {
            name: 'SubCategories'
          }
        },
        {
          name: 'Create',
          to: {
            name: 'SubCategoryCreate'
          }
        }
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>新增子分類</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>

    <!--  -->
    <SubCategoryEditCreate></SubCategoryEditCreate>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SubCategoryEditCreate from '@/views/C-2__SubCategory/c/SubCategoryEditCreate.vue';
import Breadscrumbs from '@/components/Breadscrumbs.vue';

export default {
  components: {
    SubCategoryEditCreate,
    Breadscrumbs,
  },
  computed: {
    ...mapState(['currentBuTabId']),
    ...mapState('subcategory', ['subcategory']),
  },
  created() {
    this.setSubCategory({
      bu_id: this.currentBuTabId,
      specs: [],
      filters: [],
    });
  },
  methods: {
    ...mapActions('subcategory', ['setSubCategory', 'save', 'clear']),
    cancelHandler() {
      this.$router.push({ name: 'SubCategories' });
    },
    saveHandler() {
      this.save(this.subcategory).then(() => {
        this.$router.push({ name: 'SubCategories' });
        this.clear();
      });
    },
  },
};
</script>
